import React, { Component } from "react";
import Feedback from "components/Feedback/Feedback";
import { connect } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";

class FeedbackContainer extends Component {
  constructor(props) {
    super(props);
    this.webinarId = Number(props.params.id);
    this.feedbackId = Number(props.params.feedbackId);
    this.state = {
      feedback: {},
      questions: [],
      showPopup: false,
    };
  }

  componentDidMount = () => {
    console.log("FeedbackPage");

    window.scrollTo(0, 0);
    axios.get(`/api/v1/feedback_forms/${this.feedbackId}`).then((res) => {
      this.setState((prev) => ({
        ...prev,
        questions: res.data.feedback_form.questions.map((item) => {
          switch (item.question_type) {
            case "rate":
              return {
                min: item.options[0],
                max: item.options[1],
                answers: ["1", "2", "3", "4", "5"],
                question: item.body,
              };
            case "topic":
              return {
                topic: item.body,
              };
            case "variant":
              return {
                answers: item.options,
                question: item.body,
              };
            case "text":
              return {
                text: item.body,
              };
            default:
              return {};
          }
        }),
      }));
    });
  };

  onChange = (item, event) => {
    this.setState({
      feedback: {
        ...this.state.feedback,
        [item.text || item.question]: event.target.value,
      },
    });
  };

  onTextAreaChange = (event) => {
    this.onItemChange(
      {
        label: "additionalComment",
        question:
          "Please provide any additional comments in relation to the organisation of the activity.",
      },
      event
    );
  };

  onSubmit = () => {
    if (Object.keys(this.state.feedback).length < 1) {
      toast.warning("At least one field is required to be filled");
      return;
    }

    const evaluation_forms = Object.keys(this.state.feedback).map((key) => ({
      question: key,
      answer: this.state.feedback[key],
    }));

    axios
      .post("api/v1/evaluation_forms", {
        webinar_id: this.webinarId,
        evaluation_forms,
      })
      .then(() => {
        this.setState({ ...this.state, showPopup: true });
      });
  };

  render() {
    return (
      <Feedback
        feedback={this.state.feedback}
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        showPopup={this.state.showPopup}
        webinarId={this.webinarId}
        questions={this.state.questions}
      />
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackContainer);



// WEBPACK FOOTER //
// ./src/containers/Feedback/Feedback.js